import AbstractProvider from '../services/App/AbstractProvider';
import {IDatabase} from '../@interfaces/services/Database';
import {IStoreEvents} from '../@interfaces/services/StoreEvents/IStoreEvents';
import {IReduxNavigationState} from '../@interfaces';
import {fetchNavigationConfig, setNavigationConfig} from '../_redux/navigation/actions';
import {NAVIGATION_SET_CONFIG} from '../_redux/navigation/constants';
import NavigationSetting from '../services/Database/Models/NavigationSetting';

export class NavigationProvider extends AbstractProvider {
	holdBootUntilNotCompleted = false;

	async boot(): Promise<void> {
		this.subscribeToStoreEvents();

		if (!this.app.config.get('client.store-data-in-db') as boolean) {
			return;
		}

		const table = this.getStoredService<IDatabase>('db').navigationSettings;
		if (!table) {
			return;
		}

		const config = await table.toArray().then(items => {
			return items.reduce((res, item) => {
				res[item.name] = item.routes;

				return res;
			}, {} as Exclude<IReduxNavigationState, 'loaded'>);
		});

		this.app.dispatchAction(setNavigationConfig(config));
	}

	async loading(): Promise<void> {
		if (!this.app.getStoreState()?.navigation.loaded) {
			this.app.dispatchAction(fetchNavigationConfig());
		}
	}

	protected subscribeToStoreEvents() {
		const dispatcher = this.getStoredService<IStoreEvents>('store-events');

		dispatcher.listen(NAVIGATION_SET_CONFIG, (e, payload) => {
			const config: Exclude<IReduxNavigationState, 'loaded'> = payload.action.payload;

			const records = Object.keys(config).reduce((res: any[], name) => {
				res.push([{name}, {routes: config[name as keyof typeof config]}]);

				return res;
			}, []);

			return NavigationSetting.updateOrCreateMany<NavigationSetting>(records);
		});
	}
}
